<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <!-- <loader *ngIf="showLoader"></loader> -->
    </div>
</div>